// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1LI_u","footer":"Form_footer__by7Hy"};